import React from 'react';
import { NavLink } from 'react-router-dom';
import NavigationSubmenu from './NavigationSubmenu';
import { mainMenuItems, adminMenuItems } from './config/menuItems';
import { useProfile } from '../../hooks/useProfile';

const NavigationMenu = () => {
  const { isAdmin } = useProfile(); // Use the explicit isAdmin helper

  // Combine menu items based on admin status
  const menuItems = isAdmin ? [...mainMenuItems, ...adminMenuItems] : mainMenuItems;

  return (
    <nav className="hidden md:flex space-x-4">
      {menuItems.map((item) => (
        item.submenu ? (
          <NavigationSubmenu
            key={item.name}
            label={item.name}
            icon={item.icon}
            items={item.submenu}
          />
        ) : (
          <NavLink
            key={item.name}
            to={item.path!}
            className={({ isActive }) =>
              `flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                isActive
                  ? 'text-brand bg-brand/10'
                  : 'text-content-secondary hover:text-content-primary hover:bg-background'
              }`
            }
          >
            <item.icon className="w-5 h-5" />
            <span>{item.name}</span>
          </NavLink>
        )
      ))}
    </nav>
  );
};

export default NavigationMenu;